import React from "react";
import SignInHeader from "../../components/signIn/SignInHeader";
import SignInForm from "../../components/signIn/SignInForm";
import SignInFooter from "../../components/signIn/SignInFooter";
import Footer from "../../common/Footer/Footer";
import CookieBanner from "../../components/CookieBanner/CookieBanner";
import SEO from "../../components/SEO/SEO";


const SignIn = () => {
  return (
    <>
      <SEO title="Sign In" noIndex={true} />
      <div className="block md:hidden">

          </div>
    
          <div className="flex justify-center items-center min-h-screen">
            <div className="bg-tertiary rounded-[50px] mb-16 p-6 sm:p-8 shadow-lg w-full max-w-[95%] md:max-w-[1039px] h-auto relative">
          <SignInHeader />
          <SignInForm />
          <SignInFooter />
        </div>
      </div>
      
      <div>
        <Footer />
      </div>

      {/* Cookie Banner - sadece gerektiğinde göster */}
      <CookieBanner />
    </>
  );
};

export default SignIn;